// ACTIONS
export const SET_AUTH_DATA = '[Auth] set data';
export const setAuthData = (payload) => ({ type: SET_AUTH_DATA, payload });
export const LOG_OUT = '[Auth] logout';
export const logOut = () => ({ type: LOG_OUT });
export const SET_PRODUCER_DATA = '[Auth] set producer data';
export const setProducerData = (payload) => ({ type: SET_PRODUCER_DATA, payload });
export const REMOVE_PRODUCER_DATA = '[Auth] remove producer data';
export const removeProducerData = (payload) => ({ type: REMOVE_PRODUCER_DATA, payload });
export const ADD_PRODUCER = '[Auth] add producer data';
export const addProducer = (payload) => ({ type: ADD_PRODUCER, payload });
export const REMOVE_PRODUCER = '[Auth] remove producer';
export const removeProducer = (payload) => ({ type: REMOVE_PRODUCER, payload });
export const UPDATE_TOKEN = '[Auth] update token';
export const updateToken = (payload) => ({ type: UPDATE_TOKEN, payload });

// REDUCER
const INITIAL_STATE = {
  token: '',
  userId: '',
  userData: undefined,
  producerData: undefined,
};

export default function AuthReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
  case SET_AUTH_DATA:
    return {
      ...state,
      token: action.payload.token || state.token,
      userId: action.payload.userId || state.userId,
      userData: {
        firstName: action.payload.firstName || state.userData?.firstName,
        lastName: action.payload.lastName || state.userData?.lastName,
        email: action.payload.email || state.userData?.email,
        whatsapp: action.payload.whatsapp || state.userData?.whatsapp,
        producers: action.payload.producers || state.userData?.producers,
        cpf: action.payload.cpf || state.userData?.cpf,
      },
    };

  case SET_PRODUCER_DATA:
    return {
      ...state,
      producerData: {
        producerId: action.payload.id,
        nickname: action.payload.nickname ?? undefined,
        companyName: action.payload.register?.companyName ?? undefined,
        producerName: action.payload.register?.producerName ?? undefined,
        name: action.payload.name ?? undefined,
        cpf: action.payload.register?.cpf ?? undefined,
        cnpj: action.payload.register?.cnpj ?? undefined,
        stateRegister: action.payload.register?.stateRegister ?? undefined,
      },
    };

  case REMOVE_PRODUCER_DATA:
    return {
      ...state,
      producerData: undefined,
    };

  case ADD_PRODUCER:
    return {
      ...state,
      userData: {
        ...state.userData,
        producers: state.userData.producers
          ? [...state.userData.producers, action.payload]
          : [action.payload],
      },
    };
  case REMOVE_PRODUCER:
    return {
      ...state,
      userData: {
        ...state.userData, producers: state.userData.producers.filter(((item) => item.id !== action.payload.id)),
      },
    };

  case LOG_OUT:
    return INITIAL_STATE;

  case UPDATE_TOKEN:
    return { ...state, token: action.payload };

  default:
    return state;
  }
}
